// extracted by mini-css-extract-plugin
export var alternate = "_1k-h";
export var black = "_1k-3";
export var blue = "_1k-d";
export var blueLight = "_1k-c";
export var brand = "_1k-7";
export var error = "_1k-9";
export var gray = "_1k-6";
export var grayBlue = "_1k-b";
export var iconWrapper = "_1k-4";
export var indigo = "_1k-e";
export var orange = "_1k-g";
export var pink = "_1k-f";
export var primary = "_1k-0";
export var purple = "_1k-8";
export var success = "_1k-5";
export var warning = "_1k-a";
export var white = "_1k-1";
export var whiteSuccess = "_1k-2";